var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notion-wiki-container" },
    [
      _vm.loadPending
        ? _c("v-progress-linear", {
            attrs: { indeterminate: "", absolute: "", top: "", color: "green" },
          })
        : _vm._e(),
      _vm.showSidebar
        ? _c(
            "div",
            { staticClass: "sidebar" },
            [
              _c("v-treeview", {
                attrs: {
                  items: _vm.sidebarItems,
                  open: _vm.sidebarOpen,
                  multipleActive: "",
                  transition: "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "label",
                      fn: function (props) {
                        return [
                          _c(
                            "router-link",
                            {
                              staticClass: "sidebar-link",
                              attrs: { to: _vm.mapPageUrl(props.item.id) },
                            },
                            [_vm._v(" " + _vm._s(props.item.name) + " ")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  172947450
                ),
              }),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "sidebar" },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" },
              }),
            ],
            1
          ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("NotionRenderer", {
            attrs: {
              blockMap: _vm.currentBlockMap,
              mapPageUrl: _vm.mapPageUrl,
              mapImageUrl: _vm.mapImageUrl,
              pageLinkOptions: _vm.$options.pageLinkOptions,
              customBlockComponents: _vm.customBlocks,
              fullPage: "",
              prism: "",
              katex: "",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }